import EventEmitter from "./EventEmitter";
import Utils from "./Utils";
export default class FinishModal extends EventEmitter {
  constructor() {
    super();
    this.modal = document.getElementById("finishMessage");
    this.keywordResult = document.getElementById("keywordResult");
    // this.keywordMessage = document.getElementById("keywordMessage");

    this.image = document.getElementById("finishImage");
    this.initListeners();
  }

  initListeners() {
    this.handlers = {
      learnMore: this.onLearnMore.bind(this),
      share: this.onShare.bind(this),
      next: this.onNext.bind(this),
    };

    document
      .getElementById("learnMoreButton")
      .addEventListener("click", this.handlers.learnMore);
    document
      .getElementById("shareButton")
      .addEventListener("click", this.handlers.share);
    document
      .getElementById("nextButton")
      .addEventListener("click", this.handlers.next);
  }
  updateContent(asset_id, keyword, link) {
    console.log(asset_id, link);
    setTimeout(async () => {
      this.ASSET_ID = asset_id;
      this.LINK = link;
      this.KEYWORD = keyword;
      this.keywordResult.textContent = keyword;
      // load the HERO image
      let data = null;
      if (this.ASSET_ID.indexOf("/") > -1) {
        this.image.src = `images/texture/blue.gif`;
        return;
      }
      data = await Utils.loadJSON(`og/${this.ASSET_ID}`);
      console.log("data", data);
      if (data.image) this.image.src = `${data.image.url}=cc-s80`;
    }, 1500);
  }

  onLearnMore(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    this.emit("learnMore", [this.LINK]);
  }

  onShare(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    this.emit("share", [this.KEYWORD]);
  }

  onNext(e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    this.emit("next");
  }

  show() {
    this.modal.classList.add("zoomIn");
    this.modal.classList.remove("hidden");
  }

  hide() {
    this.modal.classList.remove("zoomIn");
    this.modal.classList.add("zoomOut");
    setTimeout(() => {
      this.modal.classList.add("hidden");
      this.modal.classList.remove("zoomOut");
    }, 1000);
  }
}
